import { Stack } from '@mantine/core';
import P1Medium from 'components/typography/P1Medium';
import P2Regular from 'components/typography/P2Regular';

export interface ImportMeasurementsHintProps {
  revisionKind: 'revision' | 'form';
}

/**
 * Displays an import hint for the measurements table.
 */
export default function ImportMeasurementsHint({ revisionKind }: ImportMeasurementsHintProps) {
  return (
    <Stack spacing={16}>
      <Stack spacing={8}>
        <P1Medium>1. Schéma dokumentu</P1Medium>
        <P2Regular>
          Pre import meraní pre zariadenie je potrebné dodržať výchozie poradie stĺpcov v tabuľke meraní. V opačnom
          prípade, import zlyhá.{' '}
          {revisionKind === 'revision'
            ? 'Pre každý typ revíznej správy je definovaný vlastný formát meraní.'
            : 'Pre každý typ formulára je definovaný vlastný formát meraní.'}
        </P2Regular>
        <P2Regular>
          Názvy stĺpcov v prvom riadku musia presne zodpovedať exportovanému súboru vrátane poradia. Posledný stĺpec je
          vyhradený pre Nedostatky.
        </P2Regular>
      </Stack>
      <Stack spacing={8}>
        <P1Medium>2. Hodnoty</P1Medium>
        <P2Regular>
          Textové polia prijímajú ľubovoľný text. Číselné polia prijímajú iba platné čísla, pričom je možné použiť
          desatinnú bodku aj čiarku. Ak má pole nastavené minimum, maximum alebo presnosť, tieto pravidlá sa pri importe
          kontrolujú.
        </P2Regular>
        <P2Regular>
          Dátumy musia byť vo formáte yyyy-mm-dd, dd.mm.yyyy alebo mm/dd/yyyy. Checkbox polia rozpoznávajú hodnoty
          áno/ano a true, ostatné hodnoty sa vyhodnotia ako nie. Polia typu výber musia obsahovať presne jednu z
          povolených možností.
        </P2Regular>
        <P2Regular>
          Ak sa v súbore nachádza neplatná hodnota, import sa preruší a zobrazí sa chyba s riadkom a stĺpcom, kde je
          problém. Prázdne bunky sa importujú ako prázdne hodnoty.
        </P2Regular>
      </Stack>
    </Stack>
  );
}
